import React from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Layouts
import PublicLayout from './components/layout/PublicLayout';
import PortalLayout from './components/layout/PortalLayout';

// Pages
import Home from './pages/public/Home';
import About from './pages/public/About';
import Services from './pages/public/Services';
import CaseStudies from './pages/public/CaseStudies';
import Contact from './pages/public/Contact';
import Login from './pages/portal/Login';
import Register from './pages/portal/Register';
import Dashboard from './pages/portal/Dashboard';
import ParticipantCertificates from './pages/portal/views/ParticipantCertificates';
import ParticipantMentoring from './pages/portal/views/ParticipantMentoring';
import ManagerTeam from './pages/portal/views/ManagerTeam';
import ManagerCompliance from './pages/portal/views/ManagerCompliance';
import AdminSettings from './pages/portal/views/AdminSettings';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-navy-900 text-white">
        <div className="w-12 h-12 border-4 border-gold-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="font-serif italic text-gold-500">Securing your session...</p>
      </div>
    );
  }

  if (!user) {
    // CRITICAL: Redirect to /portal/login NOT /
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/portal/dashboard" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="case-studies" element={<CaseStudies />} />
            <Route path="contact" element={<Contact />} />
          </Route>

          <Route path="/portal/login" element={<Login />} />
          <Route path="/portal/register" element={<Register />} />

          <Route path="/portal" element={<ProtectedRoute><PortalLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="participant/certificates" element={<ProtectedRoute allowedRoles={['participant', 'admin']}><ParticipantCertificates /></ProtectedRoute>} />
            <Route path="participant/mentoring" element={<ProtectedRoute allowedRoles={['participant', 'admin']}><ParticipantMentoring /></ProtectedRoute>} />
            <Route path="manager/team" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><ManagerTeam /></ProtectedRoute>} />
            <Route path="manager/compliance" element={<ProtectedRoute allowedRoles={['manager', 'compliance', 'admin']}><ManagerCompliance /></ProtectedRoute>} />
            <Route path="admin/settings" element={<ProtectedRoute allowedRoles={['admin']}><AdminSettings /></ProtectedRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;